import { render, staticRenderFns } from "./RepresReports.vue?vue&type=template&id=70fcad45"
import script from "./RepresReports.vue?vue&type=script&lang=js"
export * from "./RepresReports.vue?vue&type=script&lang=js"
import style0 from "./RepresReports.vue?vue&type=style&index=0&id=70fcad45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports